import { useTranslation } from "react-i18next";
import image from '../../img/Accounts/need_help.png';
import Button from "../Button";

const NeedHelp = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto sm:mx-[20px] relative">
                <div className="bg-[#15318D] sm:rounded-[20px] xl:px-[70px] px-[30px] xl:pt-[90px] pt-[40px] xl:pb-[75px] md:pb-[40px]">
                    <div className="relative z-10 text-center xl:w-[460px] md:w-[340px]">
                        <h2 className="text-[#63ABFF] font-[700] text-[28px] xl:text-[45px]">
                            {t('accounts.need_help.title')}
                        </h2>
                        <p className="mt-[15px] sm:text-[19px] text-[17px] text-[#fff] font-[600]">
                            {t('accounts.need_help.text')}
                        </p>
                        <Button className="mt-[40px]" color="#EFEFEF" text="#0C2780" />
                    </div>
                    <img className="md:absolute relative z-0 xl:w-[602px] md:w-[400px] w-full max-w-[400px] md:max-w-[unset] bottom-0 md:right-[30px] flex mx-auto mt-[50px] md:mt-0" src={image} alt='' />
                </div>
            </div>
        </section>
    )
};

export default NeedHelp;
